// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2tm8E","upload":"Small_upload__3sz3L","imageWrap":"Small_imageWrap__3Wcrz","removeBtn":"Small_removeBtn__xiB5p"};